import Vue from 'vue'

import { $themeConfig } from '@themeConfig'

const COURIERS_API_URL = `${$themeConfig.app.courierUrl}/couriers`

export function fetchCouriers(divisionId, signal) {
    return Vue.axios.get(`${COURIERS_API_URL}`, {
        params: {
            division_id: divisionId,
        },
        signal,
    })
}
